import React from "react";
import "./MemberCard.css";
function MemberCard(props) {
  return (
    <>
      <div class="our-team">
        <div class="picture">
          <img
            class="img-fluid"
            src={props.imgLink}
          />
        </div>
        <div class="team-content">
          <h3 class="name">{props.name}</h3>
          <h4 class="title">{props.position}</h4>
        </div>
        <ul class="social">
          <li>
          <a href="#"><i class="fab fa-linkedin-in"></i></a>

          </li>
          <li>
          <a href="#"><i class="fab fa-linkedin-in"></i></a>

          </li>
          <li>
          <a href="#"><i class="fab fa-linkedin-in"></i></a>
          </li>
          <li>
          <a href="#"><i class="fab fa-linkedin-in"></i></a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default MemberCard;
